import AnalyticsHelper from '../../utils/analytics-helper.js';
import OpeningHours from '../../utils/opening-hours.js';
import DealerMapper from '../../utils/dealer-mapper.js';

export default class SelectedDealer {
    constructor(parent, router) {
        this.router = router;
        this.el = parent.el.querySelector('.selected-dealer');
        this.url = this.el.dataset.url;
        this.closedLabel = this.el.dataset.closedLabel;
        this.name = this.el.querySelector('.dealer-name');
        this.address = this.el.querySelector('.dealer-address');
        this.hours = this.el.querySelector('.timing');
        this.phone = parent.el.querySelector('.dealer-telephone a');
        this.website = this.el.querySelector('.dealer-website a');
        this.directions = this.el.querySelector('.dealer-directions a');
        this.type = this.el.querySelector('.dealer-type');
    }

    show() {
        const param = this.router.params.get('dealer');
        if (param) {
            const dealer = this.router.data.dealers ? this.router.data.dealers.find((dealer) => dealer.uri === param) : null;
            dealer ? this.populate(dealer) : this.get(param);
        }
    }

    get(dealer) {
        const filter = this.router.data.filter;
        const data = new FormData();
        data.append('dealer', dealer);
        return fetch(this.url, { method: 'POST', body: data })
            .then(this.valid)
            .then((response) => response.json())
            .then((result) => DealerMapper.map(result, filter))
            .then((dealer) => this.save(dealer))
            .then((dealer) => this.populate(dealer))
            .catch((error) => this.invalid());
    }

    save(dealer) {
        this.router.data.dealers ? this.router.data.dealers.push(dealer) : this.router.data.dealers = [dealer];
        return dealer;
    }

    populate(dealer) {
        if (this.name) { this.name.innerHTML = dealer.name; }
        if (this.address) { this.address.innerHTML = dealer.address.formatted; }
        if (this.hours) { this.hours.innerHTML = OpeningHours.html(dealer.openingHours, this.closedLabel); }
        if (this.phone) {
            this.phone.href = `tel:${dealer.telephone}`; this.phone.innerHTML = dealer.telephone;
            AnalyticsHelper.template(this.phone, { dealer: dealer.uri });
        }
        if (this.directions) {
            this.directions.href = `https://www.google.com/maps/dir//${dealer.name},${dealer.address.formatted}/@${dealer.address.lat},${dealer.address.lng}`;
            AnalyticsHelper.template(this.directions, { dealer: dealer.uri });
        }
        if (this.website) {
            if (dealer.website) {
                this.website.classList.remove('hide');
                this.website.href = dealer.website;
                AnalyticsHelper.template(this.website, { dealer: dealer.uri });
            } else {
                this.website.classList.add('hide');
            }
        }
        if(this.type) {
            if(dealer.type) {
                this.type.classList.remove('hide');
                this.type.querySelector('strong').innerHTML = dealer.type;
            } else {
                this.type.classList.add('hide');
            }
        }
    }

    valid(response) {
        if (!response.ok) {
            throw Error(response.statusText);
        }
        return response;
    }

    invalid() {
        this.router.params.delete('dealer');
        this.router.update('search');
    }
}
